module.exports = __webpack_public_path__ + "img/order-reached.43f24ace.svg";